import axios from "@/plugins/axios";
import { actionTypes as websiteActionTypes, actionTypes, mutationTypes } from "./types";
import { showMessage } from "@/helpers/messages.js";
import store from "@/store/store";
import { getterTypes as publisherGetterTypes } from "@/store/Publisher/types";

export const actions = {
    async [actionTypes.getData]({ commit }) {
        commit(mutationTypes.websitesGetDataStart);
        return axios({
            method: "get",
            url: "sql/list-website",
            params: {
                ts: Date.now(),
            },
        }).then(
            (data) => {
                commit(mutationTypes.websitesGetDataSuccess, data.data);
                return data.data;
            },
            () => {
                commit(mutationTypes.websitesGetDataFailure);
            }
        );
    },
    async [actionTypes.getDataByPublisher]({ commit }, { publisherId }) {
        commit(mutationTypes.websitesGetDataByPublisherStart);

        let params = new URLSearchParams("");
        params.append("is_lite", "1");
        if (publisherId && publisherId !== "all") {
            params.append("publisher", publisherId);
        }
        const url = "/sql/website?" + params.toString();

        return axios({
            method: "get",
            url: url,
        }).then(
            (data) => {
                commit(mutationTypes.websitesGetDataByPublisherSuccess, data.data);
                return data.data;
            },
            () => {
                commit(mutationTypes.websitesGetDataByPublisherFailure);
            }
        );
    },
    [actionTypes.addData]({ commit, dispatch }, payload) {
        commit(mutationTypes.websiteAddStart);
        payload["performax_id"] = parseInt(payload["performax_id"]);

        return axios({
            method: "post",
            url: "sql/website",
            data: payload,
        }).then(
            (data) => {
                showMessage(data.data, "creat", "website");
                if (data.data.success) {
                    const publisher = store.getters[publisherGetterTypes.getPublisher];
                    dispatch(websiteActionTypes.getDataByPublisher, { publisherId: publisher.id });
                    commit(mutationTypes.websiteAddSuccess, data.data);
                } else {
                    commit(mutationTypes.websiteAddEditFormError, data.data.error);
                }
            },
            () => {
                commit(mutationTypes.websiteAddFailure);
            }
        );
    },
    [actionTypes.editData]({ commit, dispatch }, payload) {
        commit(mutationTypes.websiteEditStart);

        let formattedDate = null;
        if (payload.stats_hide_from) {
            const date = new Date(payload.stats_hide_from);
            formattedDate = date.toISOString().slice(0, 10);
        }

        const body = {
            aab_site_id: payload.aabSiteId,
            publisher: payload.publisher,
            cpm: payload.cpm,
            state: payload.status,
            site_name: payload.site_name,
            performax_id: payload.performax_id ? parseInt(payload.performax_id) : null,
            is_stats_visible: payload.is_stats_visible ? 1 : 0,
            stats_hide_from: formattedDate,
        };
        return axios({
            method: "put",
            url: "sql/website",
            data: body,
        }).then(
            (data) => {
                showMessage(data.data, "sav", "website");
                if (data.data.success) {
                    commit(mutationTypes.websiteEditSuccess, data.data);
                    const publisher = store.getters[publisherGetterTypes.getPublisher];
                    dispatch(websiteActionTypes.getDataByPublisher, { publisherId: publisher.id });
                } else {
                    commit(mutationTypes.websiteAddEditFormError, data.data.error);
                }
            },
            () => {
                commit(mutationTypes.websiteEditFailure);
            }
        );
    },
    [actionTypes.deleteData]({ commit, dispatch }, { aab_site_id }) {
        commit(mutationTypes.websiteDeleteStart);
        return axios({
            method: "delete",
            url: `sql/website/${aab_site_id}`,
        }).then(
            (data) => {
                const publisher = store.getters[publisherGetterTypes.getPublisher];
                dispatch(websiteActionTypes.getDataByPublisher, { publisherId: publisher.id });
                showMessage(data.data, "delet", "website");
                commit(mutationTypes.websiteDeleteSuccess, data.data);
            },
            () => {
                commit(mutationTypes.websiteDeleteFailure);
            }
        );
    },
    [actionTypes.changeMonetize]({ commit }, { aab_site_id, monetize_status }) {
        commit(mutationTypes.websiteEditStart);

        return axios({
            method: "put",
            url: `la/website/monetize/${aab_site_id}`,
            data: { monetize: monetize_status },
        }).then(
            (data) => {
                commit(mutationTypes.websiteEditSuccess, data.data);
            },
            () => {
                commit(mutationTypes.websiteEditFailure);
            }
        );
    },
};
